module.exports = __webpack_public_path__ + "img/hotmart.6c8df478.png";